import React from 'react'
import {TextField, Typography,Button, Grid,Card} from '@mui/material';
import { useLocation } from 'react-router-dom';


const RouteBasedButtonGroup = (props) => 
{
    const[state, setState] = React.useState([])     
    const[selectedValue, setSelectedValue] = React.useState("")
    const[isFirstRender, setIsFirstRender] = React.useState(true)
    const location = useLocation()

    React.useEffect(()=>{          
        //getSelectionFromRoute(location.pathname.slice(location.pathname.lastIndexOf('/') + 1 , location.pathname.length))
        getSelectionFromRoute(getSpecificRoutePart(props.routeEndpointPosition))
    },[location.pathname.slice(location.pathname.lastIndexOf('/') + 1 , location.pathname.length)])

    React.useEffect(()=>{
        if(isFirstRender)
        {
            addIsSelectedPropToState(props.state)
            setIsFirstRender(false)
        }
    },[isFirstRender])

    const getSpecificRoutePart = (position) => 
    {   
        var arr = []
        for (let i = 0; i < location.pathname.length; i++) {
            if(location.pathname[i] === '/')
            {
                if(location.pathname[location.pathname.indexOf('/', i+1)] !== '/')
                {
                    arr.push(location.pathname.slice(i+1,location.pathname.length))
                }
                else
                {
                    arr.push(location.pathname.slice(i+1,location.pathname.indexOf('/', i+1)))
                }
            }
        }
        return arr[position]     
    }

    const getSelectionFromRoute = (route) => 
    {    
        if(state.map(el => el.value).includes(route))
        {
            changeSelectedButton(route)
            setSelectedValue(route)
        }
    }

    const addIsSelectedPropToState = (state) => 
    {
        if(typeof state !== 'undefined' )
        {
            var newState = state.map(obj => {
                obj['isSelected'] = false;    
                if(props.hasOwnProperty('noInitialSelection') === false)
                {
                     state[0].isSelected = true;
                     setSelectedValue(state[0].value)
                     props.sendValue(state[0].value) 
                }           
                return obj
             })
             setState(newState)
        }   
    }

    const handleButtonClick = (e) =>
    {
        changeSelectedButton(e.currentTarget.value)
        setSelectedValue(e.currentTarget.value)
        props.sendValue(e.currentTarget.value)        
    }

    const changeSelectedButton = (newSelectedValue) => 
    {
        if(newSelectedValue !== selectedValue)
        {    
            var newState = state.map(option => {
                if(option.isSelected === true)
                {
                    return {...option, isSelected:false}  
                }
                if(option.value === newSelectedValue)
                {
                    return {...option, isSelected:true}
                }
                return option
            }) 
            setState(newState)   
        }
    }

    return(
        <>
            {state.map((option, index) => {
                return(
                    <Grid item key={index}>
                        <Button sx={option.isSelected ? props.selectedButtonStyle : props.defaultButtonStyle} value={option.value} onClick={handleButtonClick} >
                            {option.display}
                        </Button> 
                    </Grid>                                                                                                   
                )                          
            })}
        </>
    )
}
export default RouteBasedButtonGroup
